export interface BanReason {
  id: string;
  category?: string;
  type: string;
  first: string;
  second: string;
  third: string;
  icon: BanReasonCode;
}

export type BanReasonCode =
  | 'Gamepad2'
  | 'Terminal'
  | 'PenLine'
  | 'Users'
  | 'Megaphone'
  | 'MessageSquareWarning'
  | 'ThumbsDown'
  | 'MessageSquareOff'
  | 'Strikethrough'
  | 'Copy'
  | 'AudioLines';

export const banReasons: BanReason[] = [
  {
    id: 'ABUS',
    category: 'Cheating',
    type: 'Abusing game mechanics (bugs, glitches, exploits)',
    first: 'Suspension for 72 hours',
    second: 'Suspension for 7 days with warning before closure',
    third: 'Permanent suspension',
    icon: 'Gamepad2',
  },
  {
    id: 'THIRD',
    category: 'Cheating',
    type: 'Using third-party software',
    first: 'Suspension for 7 days with warning before closure',
    second: 'Permanent suspension',
    third: 'N/A',
    icon: 'Terminal',
  },
  {
    id: 'MOD',
    category: 'Cheating',
    type: 'Modifying game files',
    first: 'Suspension for 72 hours',
    second: 'Suspension for 7 days with warning before closure',
    third: 'Permanent suspension',
    icon: 'PenLine',
  },
  {
    id: 'UNAUTH',
    category: 'Cheating',
    type: 'Unauthorized account access',
    first: 'Suspension for 24 hours',
    second: 'Suspension for 72 hours',
    third: 'Suspension for 7 days',
    icon: 'Users',
  },
  {
    id: 'HARASS',
    category: 'Behavior & Communication',
    type: 'Harassment, threats',
    first: 'Suspension for 3 hours',
    second: 'Suspension for 24 hours',
    third: 'Suspension for 72 hours',
    icon: 'Megaphone',
  },
  {
    id: 'INSULT',
    category: 'Behavior & Communication',
    type: 'Insults, vulgarity',
    first: 'Suspension for 3 hours',
    second: 'Suspension for 24 hours',
    third: 'Suspension for 72 hours',
    icon: 'MessageSquareWarning',
  },
  {
    id: 'TOXIC',
    category: 'Behavior & Communication',
    type: 'Toxicity',
    first: 'Warning',
    second: 'Suspension for 3 hours',
    third: 'Suspension for 24 hours',
    icon: 'ThumbsDown',
  },
  {
    id: 'INAPP',
    category: 'Behavior & Communication',
    type: 'Highly inappropriate statements (hatred, discrimination, etc.)',
    first: 'Suspension for 24 hours',
    second: 'Suspension for 72 hours',
    third: 'Suspension for 7 days',
    icon: 'MessageSquareOff',
  },
  {
    id: 'INAPPN',
    category: 'Names',
    type: 'Inappropriate, vulgar',
    first: 'Warning',
    second: 'Suspension for 3 hours',
    third: 'Suspension for 24 hours',
    icon: 'Strikethrough',
  },
  {
    id: 'IMPERSON',
    category: 'Names',
    type: 'Impersonation',
    first: 'Warning',
    second: 'Suspension for 3 hours',
    third: 'Suspension for 24 hours',
    icon: 'Copy',
  },
  {
    id: 'HIGHOFF',
    category: 'Names',
    type: 'Highly offensive (hatred, discrimination, etc.)',
    first: 'Suspension for 24 hours',
    second: 'Suspension for 72 hours',
    third: 'Suspension for 7 days',
    icon: 'AudioLines',
  },
];

export function getReasonFromCode(code: string): BanReason | undefined {
  return banReasons.find((reason) => reason.id === code);
}
